import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, Complaint } from "../store_types"
import { callComplaintsAPI, callDownloadComplaintsAPI, callComplaintsBulkUpdateAPI } from "../../api/complaints"
import { HTTP_STATUS_NO_CONTENT } from "../../api/index"
import { AxiosResponseHeaders } from "axios"
import { saveAs } from "file-saver"

const getDefaultState  = () => {
  return {
    complaints: [],
    complaintsPublished: false
  }
}

const complaints = {
  state: () => getDefaultState(),

  getters: {
    complaints (state : State) {
      return state.complaints
    },
    complaintsPublished (state : State) {
      return state.complaintsPublished
    },
  },

  actions: {
    fetchComplaints({ dispatch, commit, getters }: { dispatch: (actionName: string, result: boolean) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders | Array<Complaint> | boolean) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callComplaintsAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedComplaintsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, complaints: Array<Complaint>, complaintsPublished: boolean) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_COMPLAINTS, complaints)
            dispatch("fetchComplaintsPublished", complaintsPublished)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    downloadComplaints({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callDownloadComplaintsAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedComplaintsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, csvData: Blob) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            const targetMonth = getters.selectedComplaintsDate as Date
            saveAs(csvData, `主訴一覧_${targetMonth.getFullYear()}年${targetMonth.getMonth() + 1}月.csv`)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    updateComplaints({ dispatch, commit, getters }: { dispatch: (actionName: string) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders) => void, getters: { [key: string]: AuthHeaders }}, params: Array<{id: number, complaint: string, childAge: string}>){
      return new Promise<void>((resolve, reject) => {
        callComplaintsBulkUpdateAPI(
          getters.authHeaders as AuthHeaders,
          params,
          // Success
          (headers: AxiosResponseHeaders, status: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(status == HTTP_STATUS_NO_CONTENT) {
              dispatch("fetchComplaints")
            }
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    fetchComplaintsPublished({ commit }: { commit: (mutationType:string, published: boolean) => void}, published: boolean){
      return new Promise<void>((resolve) => {
        commit(MutationTypes.ASSIGN_COMPLAINTS_PUBLISHED, published)
        resolve()
      })
    },

    resetComplaintsState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_COMPLAINTS_STATE)
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_COMPLAINTS](state: State, complaints: Array<Complaint>) {
      state.complaints = complaints
    },
    [MutationTypes.ASSIGN_COMPLAINTS_PUBLISHED](state: State, complaintsPublished: boolean) {
      state.complaintsPublished = complaintsPublished
    },
    [MutationTypes.RESET_COMPLAINTS_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  }
}

export default complaints
